import './App.scss';
import { Routes, Route } from 'react-router-dom' 
import Home from './components/Home/Home';
import Platform from './components/Platform/Platform';
import Company from './components/Company/Company';
import ContactUs from './components/ContactUs/ContactUs';
import Login from './components/UrlRedirec/Login';
import ShopifyFAQ from './components/Other/ShopifyFAQ';
import FAQ from './components/Other/Faq';
import PrivacyPolicy from './components/Other/Privacy';
import ShopifyPricingPlans from './components/Other/ShopifyPricingPlans';
import Pricing from './components/Other/Pricing';
import Dashboard from './components/UrlRedirec/Dashboard';
import CFBlog from './components/UrlRedirec/CFBlog';
import PageNotFound from './components/UrlRedirec/PageNotFound';

function App() {
  return (
    <Routes>
      <Route path='/' element={<Home />} />
      <Route path='/platform' element={<Platform/>} />
      <Route path='/company' element={<Company />} />
      <Route path='/free-trial' element={<ContactUs/>}/>
      <Route path='/contact-us' element={<ContactUs/>} />
      <Route path='/login' element={<Login />} />
      <Route path='/dashboard' element={<Dashboard />} />
      <Route path='/blog' element={<CFBlog />} />
      <Route path='/privacy' element={<PrivacyPolicy/>} />
      <Route path='/shopify-faq' element={<FAQ/>} />
      <Route path='/shopify-pricing-plans' element={<ShopifyPricingPlans/>} />
      <Route path='/pricing' element={<Pricing/>} />
      <Route path='/faq' element={<FAQ/>} />
      <Route path='*' element={<PageNotFound/>} />
    </Routes>
  );
}

export default App;
